import { IAppState } from '../../redux';
import { selectBalance } from '../user';
import { selectTotalAmount } from './selectTotalAmount';

/**
 * Возвращает разницу между итоговой стоимостью услуг и количеством денег на счету пользователя с округлением в **большую** сторону.
 */
export const selectPaymentDeltaAmount = (state: IAppState): number => {
  const { price } = selectTotalAmount(state);
  const balance = selectBalance(state);

  return Math.ceil(Math.abs(price - balance));
};
